module.exports = __webpack_public_path__ + "static/media/18_Maf_NuestroEquipo_JoseUribe.e9d443d1.jpg";